import { isE2EQAEnvironment, isProductionEnvironment, normalizeEnvironment } from "../environment";

// OneGraph endpoint URLs and API keys for the RN ViewJob web client.
// The API keys below are registered under the `viewjob-web` client in the one-graph-configs repo.
export const ONE_GRAPH_API_URL_PROD = "https://apis.indeed.com/graphql";
export const ONE_GRAPH_API_URL_QA = "https://apis.qa.indeed.net/graphql";
export const ONE_GRAPH_API_URL_E2EQA = "https://apis.qa.indeed.net/graphql/e2eqa";
export const ONE_GRAPH_API_KEY_PROD =
  "c2e9490de290393e9ff159eff49a8e2eeb41bcead922d23ae8a8eea2f3e83014";
export const ONE_GRAPH_API_KEY_QA =
  "4cb03e546fb270e584ea3fd999d31424d07b957748f96e059ae34e5bfea87580";

export type OneGraphConfig = { url: string; apiKey: string };

/**
 * Resolves the OneGraph endpoint + API key for a given staging level.
 *
 * `normalizeEnvironment` collapses production aliases → 'prod', keeps e2eqa as
 * 'e2eqa', maps everything else (qa/stage/dev/local/...) → 'qa', and
 * unknown/null/undefined/empty → 'prod' (normalize Phase-1 default). Production
 * routes to the prod endpoint; e2eqa routes to its own endpoint but authenticates
 * with the qa API key (no distinct e2eqa key exists); all remaining qa-family
 * environments share the qa endpoint. Server-side hosts may override only the
 * URL (for example, to use service mesh) while retaining the environment's key.
 */
export function resolveOneGraphConfig(
  env: string | null | undefined,
  urlOverride?: string | null,
): OneGraphConfig {
  const normalized = normalizeEnvironment(env);
  if (isProductionEnvironment(normalized)) {
    return { url: urlOverride || ONE_GRAPH_API_URL_PROD, apiKey: ONE_GRAPH_API_KEY_PROD };
  }
  if (isE2EQAEnvironment(normalized)) {
    return { url: urlOverride || ONE_GRAPH_API_URL_E2EQA, apiKey: ONE_GRAPH_API_KEY_QA };
  }
  return { url: urlOverride || ONE_GRAPH_API_URL_QA, apiKey: ONE_GRAPH_API_KEY_QA };
}
